import GuidanceRegistry from "../guidance-registry";
import {modalService} from "../../framework";
import EmployerTakeoverPlans from "../../employer/EmployerTakeoverPlans.vue";


GuidanceRegistry.register({
  type: "action-item-ewf-guided-setup-employer-takeover-plans",
  prompt: 'Do you have plans with another vendor and do you wish to transfer those balances to Ameriflex? (additional fees may apply)',
  actions: [
    {
      text: "Yes",
      recommended: true,
      visible: () => true,
      click: async(component, guidanceItem) => {
        let response = await modalService.show("employer-takeover-plans", EmployerTakeoverPlans, {
          width: 600,
          employerId: guidanceItem.employerId,
          orderId: guidanceItem.orderId
        });

        if (response) {
          component.clickCompleteAction(guidanceItem);
        }
      }
    },
    {
      text: "No",
      visible: () => true,
      click: async (component, guidanceItem) => {
        component.clickCompleteAction(guidanceItem);
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-employer-takeover-plans.js